import type { StripeProduct } from "@/API";
import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient } from "aws-amplify/api";
import { listProducts } from "@/graphql/queries";

const client = generateClient();

export const listProductsState = create<State<StripeProduct[]>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const getListProductsIsloading = () =>
  listProductsState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const getListProductsIsError = (error: Error) =>
  listProductsState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const getListProductsIsSuccess = (listProducts: StripeProduct[]) =>
  listProductsState.setState(() => ({
    data: listProducts,
    isLoading: false,
    error: null,
  }));

export const getListProducts = async () => {
  getListProductsIsloading();

  try {
    const { data } = await client.graphql({
      query: listProducts,
    });

    getListProductsIsSuccess(data.listProducts as StripeProduct[]);
  } catch (e) {
    const errorMessage =
      e instanceof Error ? e.message : "failed to query get restaurant details";
    getListProductsIsError(Error(errorMessage));
  }
};
